import styled from 'styled-components';

export const PreviousTestExecutionsStyled = styled.article`
  display: flex;
  flex-direction: column;
  padding: 60px 0 20px;
`;

export const PreviousTestExecutionsTitleStyled = styled.div`
  margin-bottom: 24px;
`;

export const PreviousTestExecutionsDetailsStyled = styled.div``;

export const PreviousTestExecutionsTableTabsStyled = styled.div`
  margin: 32px 0;
`;

export const PreviousTestExecutionsTablesStyled = styled.div``;
